import { render, staticRenderFns } from "./CompanySettings.vue?vue&type=template&id=38f4f78c&scoped=true&"
import script from "./CompanySettings.vue?vue&type=script&lang=js&"
export * from "./CompanySettings.vue?vue&type=script&lang=js&"
import style0 from "./CompanySettings.vue?vue&type=style&index=0&id=38f4f78c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f4f78c",
  null
  
)

export default component.exports